<script setup lang="ts">
import { type Shift, type ShiftWithoutFinancialInformation } from '@/api/shifts';
import { AI_SUMMARY_AUTHOR_LINE } from '@/utils/clinical-author';

const props = defineProps<{ shift: Shift | ShiftWithoutFinancialInformation }>();

const noSummaryText = 'Actualmente no hay un resumen para este turno.';
</script>
<template>
  <v-col class="mt-2 ml-1">
    <v-card-text class="text-subtitle-2">
      <div
        v-if="props.shift.reportImagesSummary"
        class="text-caption text-medium-emphasis mb-2"
        data-testid="ai-summary-author"
      >
        {{ AI_SUMMARY_AUTHOR_LINE }}
      </div>
      {{ props.shift.reportImagesSummary || noSummaryText }}
    </v-card-text>
  </v-col>
</template>
